import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  return _openBlock(), _createBlock(_component_b_spinner, {
    style: _normalizeStyle($options.style)
  }, null, 8, ["style"]);
}